const BLOCKLIST = new Set([
  'ass', 'asshole', 'arse', 'arsehole',
  'bastard',
  'bitch', 'bitches',
  'bollocks',
  'cock', 'cocksucker',
  'cunt',
  'damn',
  'dick', 'dickhead',
  'dildo',
  'douche', 'douchebag',
  'fag', 'faggot',
  'fuck', 'fucker', 'fucking', 'fuckface',
  'goddamn',
  'handjob',
  'jerk', 'jerkoff',
  'motherfucker',
  'nigger', 'nigga',
  'piss', 'pissed', 'pisshead',
  'prick',
  'pussy',
  'retard', 'retarded',
  'shit', 'shite', 'shithead', 'shitface',
  'skank',
  'slut', 'sluts',
  'spastic',
  'twat',
  'wank', 'wanker',
  'whore', 'whores',
]);

const LEET_MAP: Record<string, string> = {
  '0': 'o',
  '1': 'i',
  '3': 'e',
  '4': 'a',
  '5': 's',
  '7': 't',
  '@': 'u',
  '$': 's',
  '!': 'i',
  '+': 't',
  '|': 'i',
};

function normalise(value: string): string {
  let output = '';
  for (const character of value.toLowerCase()) {
    output += LEET_MAP[character] ?? character;
  }
  return output.replace(/[^a-z0-9]+/g, ' ').trim();
}

export function sanitiseAvatarDisplayName(value: string, maxLength = 32): string {
  return value.trim().replace(/\s+/g, ' ').slice(0, maxLength);
}

export interface AvatarNameValidation {
  valid: boolean;
  value?: string;
  error?: string;
}

export function validateAvatarDisplayName(value: string): AvatarNameValidation {
  const sanitised = sanitiseAvatarDisplayName(value);
  if (!sanitised) {
    return { valid: false, error: 'Enter a display name to join the digital twin.' };
  }

  const normalised = normalise(sanitised);
  const tokens = normalised.split(' ');
  const matchesToken = tokens.some((token) => BLOCKLIST.has(token));
  const collapsed = normalised.replace(/\s+/g, '');
  const matchesCompound = Array.from(BLOCKLIST).some(
    (word) => word.length >= 4 && collapsed.includes(word),
  );

  if (matchesToken || matchesCompound) {
    return {
      valid: false,
      error: 'Choose a different display name. Inappropriate language is not allowed.',
    };
  }

  return { valid: true, value: sanitised };
}
